<template>
  <div class="typed-on-paper">
    On {{hist_date}}, {{this.subunits.length}} participated in this mission, {{name}}
  </div>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "MissionLobbySynop",
  props: {
    id: {
      type: Number,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    real_date: {
      type: String,
      default: null
    },
    hist_date: {
      type: String,
      default: null
    },
    mission_status: {
      type: Number,
      default: null
    },
    front_image: {
      type: String,
      default: null
    }
  },
  computed: {

    unit: function () {

      return this.filterByKey("campaign_units", "depl_unit_id", this.$route.params.depl_unit_id)[0];
    },

    sorties: function () {

      if(this.subUnitStats.sorties > 1){
        return "sorties";
      } else {
        return "sortie";
      }
    },

    subunits: function () {

      return this.subTree("campaign_units", "depl_unit_id", this.$route.params.depl_unit_id);
    },

    subUnitStats: function () {

      let unit_stats = {
        sorties: 0,
        n_pilots: 0,
        pilot_ok: 0,
        pilot_ok_names: [],
        pilot_wounded: 0,
        pilot_wounded_names: [],
        pilot_pow: 0,
        pilot_pow_names: [],
        pilot_kia: 0,
        pilot_kia_names: [],
        asset_ok: 0,
        asset_damaged: 0,
        asset_lost: 0
      };
      let pilot_buffer = [];
      let pilot_status_buffer = [];
      let asset_status_buffer = [];

      let sub_units = this.subunits;
      sub_units.unshift(this.unit);
      for(let i=0; i<sub_units.length; i++){

        let unit_reports = this.filterByKeys("reports",
          {
            depl_unit_id: sub_units[i].depl_unit_id,
            accepted: 1
          }
        );
        for(let j=0; j<unit_reports.length; j++){

          let report = unit_reports[j];
          unit_stats.sorties++;

          // count pilots only once
          if(!pilot_buffer.includes(report.character_id)){
            unit_stats.n_pilots++;
            pilot_buffer.push(report.character_id);
          }
        }

        pilot_status_buffer = unit_reports.filter(
          function (item) {
            return item.pilot_status === 0;
          });
        unit_stats.pilot_ok_names.push(Array.from(new Set(pilot_status_buffer.map(
          function (item) {
            return {first_name: item.first_name, callsign: item.callsign, last_name: item.last_name};
          }
        ))));
        unit_stats.pilot_ok += pilot_status_buffer.length;

        pilot_status_buffer = unit_reports.filter(
          function (item) {
            return item.pilot_status === 1;
          });
        unit_stats.pilot_wounded_names.push(Array.from(new Set(pilot_status_buffer.map(
          function (item) {
            return {first_name: item.first_name, callsign: item.callsign, last_name: item.last_name};
          }
        ))));
        unit_stats.pilot_wounded += pilot_status_buffer.length;

        pilot_status_buffer = unit_reports.filter(
          function (item) {
            return item.pilot_status === 2;
          });
        unit_stats.pilot_pow_names.push(Array.from(new Set(pilot_status_buffer.map(
          function (item) {
            return {first_name: item.first_name, callsign: item.callsign, last_name: item.last_name};
          }
        ))));
        unit_stats.pilot_pow += pilot_status_buffer.length;

        pilot_status_buffer = unit_reports.filter(
          function (item) {
            return item.pilot_status === 3;
          });
        unit_stats.pilot_kia_names.push(Array.from(new Set(pilot_status_buffer.map(
          function (item) {
            return {first_name: item.first_name, callsign: item.callsign, last_name: item.last_name};
          }
        ))));
        unit_stats.pilot_kia += pilot_status_buffer.length;

        asset_status_buffer = unit_reports.filter(
          function (item) {
            return item.asset_status === 0;
          });
        unit_stats.asset_ok += asset_status_buffer.length;

        asset_status_buffer = unit_reports.filter(
          function (item) {
            return item.asset_status === 1;
          });
        unit_stats.asset_damaged += asset_status_buffer.length;

        asset_status_buffer = unit_reports.filter(
          function (item) {
            return item.asset_status === 2;
          });
        unit_stats.asset_lost += asset_status_buffer.length;


      }

      return unit_stats;
    },

    ...mapGetters("missionStore", [
      "filterByKey",
      "filterByKeys",
      "subTree"
    ])
  },

  methods: {

    pilot_pilots: function (number) {

      if(number > 1){
        return "pilots";
      } else {
        return "pilot";
      }
    },

    is_are: function (number) {

      if(number > 1){
        return "are";
      } else {
        return "is";
      }
    },

    was_were: function (number) {

      if(number > 1){
        return "were";
      } else {
        return "was";
      }
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/campaign/MissionLobbySynop.vue